<template>
		<v-row justify="center">
			<v-dialog v-model="customerDialog" persistent max-width="600">
				<!-- Boton de activacion Modal -->
				<template v-slot:activator="{ on }">
					<v-col align="right" justify="center" class="my-3">
						<v-btn class="mt-2" fab dark color="secondary" v-on="on">
							<v-icon dark>mdi-plus</v-icon>
						</v-btn>
					</v-col>
				</template>
				<v-card>
					<v-card-title class="headline">{{ customerDialogEditMode ? 'EDITAR' : 'CREAR'}} CLIENTE</v-card-title>
						<v-card-text>
							<v-container>
								<v-form v-model="formValidity">
									<v-row>
										<v-col cols="12" md="6">
											<v-text-field
												color="admin_accent"
												v-model="customerForEdit.name"
												label="Nombre completo"
												prepend-inner-icon="mdi-account-circle"
												:rules="textRules"
												dense
												filled />
											<v-text-field
												color="admin_accent"
												v-model="customerForEdit.phone"
												label="Teléfono"
												prepend-inner-icon="mdi-cellphone-basic"
												:rules="textRules"
												dense
												filled /> 
											<v-text-field
												color="admin_accent"
												v-model="customerForEdit.email"
												prepend-inner-icon="mdi-email"
												:rules="emailRules"
												label="Correo Electrónico"
												dense
												filled />
											<v-textarea
												color="admin_accent"
												filled
												v-model="customerForEdit.address"
												prepend-inner-icon="mdi-message-reply-text"
												label="Dirección"
												:value="customerForEdit.address"
												rows="2"/>
										</v-col>
										<v-col cols="12" md="6">
											<v-textarea
												color="admin_accent"
												filled
												v-model="customerForEdit.notes"
												prepend-inner-icon="mdi-message-reply-text"
												label="Notas Privadas"
												:value="customerForEdit.notes"
												rows="3"/>
											<v-switch
													inset class="ma-2"
													color="success"
													v-model="customerForEdit.active"
													:label="`Estado: ${customerForEdit.active ? 'Activo' : 'Inactivo'}`" />
											<v-text-field
												color="admin_accent"
												v-model="customerForEdit.user_uid"
												prepend-inner-icon="mdi-account"
												label="USER UID"
												dense
												filled />
											<!--
											<v-switch
													inset class="ma-2"
													color="success"
													v-model="createUser"
													label="¿Permiso para Login?" />
											 <v-row v-if="!customerDialogEditMode">											
												<v-text-field
													color="admin_accent"
													v-if="createUser"
													v-model="password"
													label="Contraseña sugerida"
													prepend-inner-icon="mdi-lock"
													dense
													filled /> 
											</v-row>		 -->
										</v-col>
									</v-row>
								</v-form>
							</v-container>
						</v-card-text>
						<v-card-actions>
						<v-spacer></v-spacer>
							<v-btn :loading="loading" class="white--text" color="admin_accent" @click="update" v-if="customerDialogEditMode">ACTUALIZAR CLIENTE</v-btn>
							<v-btn :loading="loading" class="white--text" color="admin_accent" @click="add" v-else>CREAR CLIENTE</v-btn>
							<v-btn outlined color="secondary" @click="close">CANCELAR</v-btn>
						</v-card-actions>
				</v-card>

			</v-dialog>
		</v-row>
</template>
<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db } from '@/main';
	export default {
		data: () => ({
			loading: false,
			createUser: false,
			password: Math.floor(Math.random() * 1000000) + 1,
			formValidity: false,
			textRules: [v => !!v || "Este dato es requerido"],
			emailRules: [
				value => !!value || 'Email is required.',
				value => value.indexOf('@') !== 0 || 'Email shoud have a username',
				value => value.includes('@') || 'Email should include an @ symbol',
				value => value.indexOf('.') - value.indexOf('@') > 1 || 'Email should contain a valid domain.',
				value => value.indexOf('.') <= value.length - 3 || 'Email should contain a valid domain extension'
			],
		}),
		methods:{
			...mapActions('authModule',['registerUser']),
			async add(){
				this.loading = true;
				this.customerForEdit.id = Math.floor(Date.now() / 1000).toString();
				this.customerForEdit.created_at = Math.floor(Date.now() / 1000).toString();

				// if (this.createUser){								
				// 	this.$store.dispatch('registerUser',{email: this.customerForEdit.email, password: this.password.toString()}, {root: true})
				// 	.then(res =>{
				// 		this.customerForEdit.user_uid = res.user.uid;
				// 	});
				// }

				await db.collection('customers').doc(this.customerForEdit.id)
					.set( this.customerForEdit )
					.then( docRef => {
							
							this.loading = false;
							this.close();
							this.$store.commit('SET_ALERT_MESSAGE', {
								show: true,
								color: 'success',
								message: 'Cliente creado satisfactoriamente',
								timeout: 1000
							});	
							})
					.catch( e => {
						console.log('error', e )
						this.loading = false;
					})
			},
			update(){
				db.collection('customers').doc(this.customerForEdit.id)
					.update( this.customerForEdit )
					.then( docRef => {
							this.close();
							this.$store.commit('SET_ALERT_MESSAGE', {
								show: true,
								color: 'success',
								message: 'Cliente actualizada satisfactoriamente',
								timeout: 1000
							});	
							})
					.catch( e => console.log('error', e ))
			},
			close(){
				this.createUser = false;
				this.$store.dispatch('customerModule/toggleCustomerDialog', {
					editMode: false,
					customer: {
						id: null,
						name: '',
						email: '',
						phone: '',
						address: '',
						role: 'customer',
						active: true,
						user_uid: '',
						notes: null
					}
				});
			}
		}, // .methods
		computed: {
			...mapGetters('customerModule',['customer','dialog','customerForEdit', 'customerDialogEditMode','customersDialog']),
			
			customerDialog: {
				get(){
					return this.customersDialog;
				},
				set(){
					this.close()
				}
			},

		} // .computed

	}
</script>